module.exports = __webpack_public_path__ + "static/media/Snake.0da1d476.png";